import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import style from './index.module.scss';

const periodOptions = [
  { value: 'seven-days', label: 'Last 7 Days' },
  { value: 'thirty-days', label: 'Last 30 Days' },
  { value: 'three-months', label: 'Last 3 Months' },
  { value: 'year', label: 'Last Year' },
  { value: 'all-time', label: 'All Time' },
];

const categoryOptions = [
  { value: 'answers', label: 'Answers' },
  { value: 'questions', label: 'Questions' },
  { value: 'shares', label: 'Shares' },
  { value: 'blog-posts', label: 'Blog Posts' },
  { value: 'all-content', label: 'All Content' },
];

function StatsHeader({ periodOption, categoryOption, handlePeriodSelect, handleCategorySelect }) {
  return (
    <div className={`row ${style.header}`}>
      <h3 className={`col ${style.col} ${style['col--title']}`}>Stats</h3>
      <div className={`col ${style.col} ${style['col--select']}`}>
        <Select 
          name='periodOption'
          value={periodOption} 
          options={periodOptions} 
          className={style.select}
          onChange={handlePeriodSelect}
        />
        <Select
          name='categoryOption'
          value={categoryOption} 
          options={categoryOptions} 
          className={style.select}
          onChange={handleCategorySelect}
        />
      </div>
    </div>
  )
}

StatsHeader.propTypes = {
  periodOption: PropTypes.string.isRequired,
  categoryOption: PropTypes.string.isRequired,
  handlePeriodSelect: PropTypes.func.isRequired,
  handleCategorySelect: PropTypes.func.isRequired,
}

export default StatsHeader;
